import React, { PureComponent } from 'react'
import DangerousHTML from 'react-dangerous-html'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { pathOr, uniq } from 'ramda'
import { generate as generateId } from 'shortid'

import PopUp from '../../../popUp'
import fetchConditions from '../../../shared/actions/fetchConditions'
import { SEARCH_FILTERS_FORM, SEARCH_PARAM_ROOM } from '../../../search/constants'
import {
  URLDateParam,
  nightsFromPeriod,
} from '../../../search/utils'
import './conditionsPopup.scss'
import { isAbTesty } from '../../../../helpers/abTesty'

export const CONDITIONS_TAB = 'conditions'
export const DETAILS_TAB = 'details'

class ConditionsPopup extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: CONDITIONS_TAB,
    }
  }

  componentDidMount() {
    const { tab } = this.props
    const { activeTab } = this.state
    window.addEventListener('resize', this.changePopUpMaxHeight)

    if (tab.length && tab !== activeTab) {
      this.onChangeTab(tab)
    }

    this.handleShowConditions()
    this.changePopUpMaxHeight()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.changePopUpMaxHeight)
  }

  onChangeTab(tabname) {
    this.setState({ activeTab: tabname })
  }

  handleShowConditions = async () => {
    const { step } = this.props

    if (step === 'first') {
      await this.handleFetchConditionOnFirstStep()
    } else {
      await this.handleFetchConditionOnSecondStep()
    }
  }

  handleFetchConditionOnFirstStep = async () => {
    const hotelId = pathOr(null, ['drupalSettings', 'basket', 'searchQuery', 'hotel_id'], window)

    const {
      fetchRatesConditions,
      dates,
      roomId,
      roomRateId,
      adults,
      childrenAges,
      apartment,
    } = this.props

    let allChildrenAges = '0,0'

    if (childrenAges && childrenAges.length) {
      const allChildrenAgesArr = uniq(childrenAges)
      allChildrenAges = allChildrenAgesArr.map(el => childrenAges.filter(e => e === el).length).join(',')
    }

    await fetchRatesConditions({
      dateIn: URLDateParam(dates[0]),
      nbNight: nightsFromPeriod(dates),
      hotel_id: hotelId,
      roomId,
      roomRateId,
      [SEARCH_PARAM_ROOM]: apartment || `${adults},${allChildrenAges}`,
    })
  }

  calculatePopUpMaxHeight = () => window.innerHeight - 150

  changePopUpMaxHeight = () => this.setState({
    popUpContentMaxHeight: this.calculatePopUpMaxHeight(),
  });

  handleFetchConditionOnSecondStep = async () => {
    const searchQuery = pathOr({
      apartment: ['2,0,0,yyHc21gQS'],
      dateIn: '2018-09-28',
      geoCode: 'V2996',
      geoType: 'VI',
      hotel_id: '6786',
      nbNight: '2',
      q: 'Paris, Ile-de-France, France',
      roomId: 'AR4P',
      roomRateId: '1KD',
    }, ['drupalSettings', 'booking', 'secondStep', 'basket', 'searchQuery'], window)
    const {
      dateIn,
      nbNight,
      hotel_id: hotelId,
    } = searchQuery

    const {
      fetchRatesConditions,
      roomId,
      roomRateId,
      adults,
      childrenAges,
    } = this.props

    const params = {
      dateIn,
      nbNight,
      hotel_id: hotelId,
      roomId,
      roomRateId,
      adults,
    }

    if (childrenAges && childrenAges.length) {
      params.childrenAges = childrenAges
    }

    await fetchRatesConditions(params)
  }

  render() {
    const { conditions, subTitle } = this.props

    if (!conditions.fetched) return null

    const {
      activeTab,
      popUpContentMaxHeight,
    } = this.state

    return (
      <PopUp>
        <div className="popin-condition">
          <div className="popin-condition__hd">
            <div
              tabIndex="0"
              role="link"
              onKeyDown={() => { }}
              onClick={() => { this.onChangeTab(CONDITIONS_TAB) }}
              className={cn('conditions-tab', { active: activeTab === CONDITIONS_TAB })}
            >
              {pathOr('', ['offerPolicy', 'title'], conditions)}
            </div>
            <div
              tabIndex="0"
              role="link"
              onKeyDown={() => { }}
              onClick={() => { this.onChangeTab(DETAILS_TAB) }}
              className={cn('detail-tab', { active: activeTab === DETAILS_TAB })}
            >
              {pathOr('', ['offerDetails', 'title'], conditions)}
            </div>
          </div>
          <div
            className="popin-condition__content"
            style={{
              maxHeight: popUpContentMaxHeight,
            }}
          >
            {subTitle && <p>{subTitle}</p>}
            {activeTab === 'conditions'
              ? (
                <div className="conditions-tab popin-tabs">
                  {isAbTesty() && (
                    <p>
                      {pathOr('', ['offerDetails', 'rateSubTitle'], conditions)}
                    </p>
                  )}
                  {pathOr([], ['offerPolicy', 'content', 'policies'], conditions).map(policy => (
                    <React.Fragment key={generateId()}>
                      <h5>
                        {policy.label}
                      </h5>
                      <p>
                        {policy.description}
                      </p>
                    </React.Fragment>
                  ))}
                </div>)
              : (
                <div className="detail-tab popin-tabs">
                  <div className="detail-tab__hd">
                    <span className="detail-tab__left">
                      {pathOr('', ['offerDetails', 'content', 'total', 'title'], conditions)}
                    </span>
                    <span className="detail-tab__right">
                      {pathOr('', ['offerDetails', 'content', 'total', 'total'], conditions)}
                    </span>
                  </div>
                  <div className="detail-tab__container">
                    {pathOr([], ['offerDetails', 'content', 'total', 'duration'], conditions).map(duration => (
                      <div className="detail-tab__fl" key={generateId()}>
                        <span className="detail-tab__left grey">
                          {duration.value}
                        </span>
                        <span className="detail-tab__right">
                          {duration.amount}
                        </span>
                      </div>
                    ))}
                    {pathOr(null, ['offerDetails', 'content', 'total', 'description'], conditions) ? (
                      <React.Fragment>
                        <div className="large-rates__club-title">
                          <div className="ico" />
                          {pathOr('', ['offerDetails', 'content', 'total', 'description', 'club', 'title'], conditions)}
                        </div>
                        <p className="large-rates__sub-title">
                          <DangerousHTML html={pathOr('', ['offerDetails', 'content', 'total', 'description', 'value'], conditions)} />
                        </p>
                      </React.Fragment>) : null}
                  </div>
                  <div className="detail-tab__hd">
                    <span className="detail-tab__left">
                      {pathOr('', ['offerDetails', 'content', 'breakfast', 'title'], conditions)}
                    </span>
                    <span className="detail-tab__right">
                      {pathOr('', ['offerDetails', 'content', 'breakfast', 'total'], conditions)}
                    </span>
                  </div>
                  <div className="detail-tab__container">
                    {pathOr([], ['offerDetails', 'content', 'breakfast', 'duration'], conditions).map(duration => (
                      <div className="detail-tab__fl" key={generateId()}>
                        <span className="detail-tab__left grey">
                          {duration.value}
                        </span>
                        <span className="detail-tab__right">
                          {duration.amount}
                        </span>
                      </div>
                    ))}
                    <p>
                      {pathOr([], ['offerDetails', 'content', 'breakfast', 'meal_description'], conditions)}
                    </p>
                    <h5>
                      {pathOr([], ['offerDetails', 'content', 'breakfast', 'tax', 'included', 'label'], conditions)}
                    </h5>
                    {pathOr([], ['offerDetails', 'content', 'breakfast', 'tax', 'included', 'value'], conditions).map(val => (
                      <p key={val}>
                        {val}
                      </p>
                    ))}
                    <h5>
                      {pathOr([], ['offerDetails', 'content', 'breakfast', 'tax', 'not_included', 'label'], conditions)}
                    </h5>
                    {pathOr([], ['offerDetails', 'content', 'breakfast', 'tax', 'not_included', 'value'], conditions).map(val => (
                      <p key={val}>
                        {val}
                      </p>
                    ))}
                  </div>
                </div>)
            }
          </div>
        </div>
      </PopUp>
    )
  }
}

ConditionsPopup.propTypes = {
  tab: PropTypes.string,
  conditions: PropTypes.objectOf(Object).isRequired,
  step: PropTypes.string.isRequired,
  dates: PropTypes.arrayOf(PropTypes.object),
  roomId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  roomRateId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  fetchRatesConditions: PropTypes.func.isRequired,
  adults: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  childrenAges: PropTypes.arrayOf(PropTypes.number),
  apartment: PropTypes.string,
}

ConditionsPopup.defaultProps = {
  tab: CONDITIONS_TAB,
  dates: null,
  childrenAges: [],
  adults: null,
  apartment: '',
}

export default connect(({
  popup: {
    data: {
      roomId,
      roomRateId,
      step,
      tab,
      adults,
      childrenAges,
      apartment,
    },
  },
  form,
  conditions,
}) => ({
  roomId,
  roomRateId,
  step,
  dates: pathOr(null, [SEARCH_FILTERS_FORM, 'dates'], form),
  conditions,
  tab,
  adults,
  childrenAges,
  apartment,
}),
dispatch => ({
  fetchRatesConditions: params => dispatch(fetchConditions(params)),
}))(ConditionsPopup)
